var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "x-text-field",
    _vm._b(
      {
        ref: "currencyTextField",
        attrs: {
          name: _vm.name,
          rules: _vm.rules,
          mask: _vm.mask,
          hint: _vm.formattedNumber,
          "persistent-hint": true,
          "hide-details": _vm.hideDetails,
          maxlength: _vm.maxLength,
          disabled: _vm.disabled,
        },
        model: {
          value: _vm.num,
          callback: function ($$v) {
            _vm.num = $$v
          },
          expression: "num",
        },
      },
      "x-text-field",
      _vm.$attrs,
      false
    )
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }